/**
 * Rule to handle objects that look like Errors.
 * We use duck-typing instead of depending on typeof because we sometimes have errors being
 * transmitted over the wire.
 */
export var redactErrorLikeObjects = {
  // Handle error like objects.
  // Note: .hasOwnProperty('message'/'stack') failes for Error objects :-/
  test: function test(propertyName, value) {
    return typeof value.message !== 'undefined' && typeof value.stack !== 'undefined';
  },
  replacement: function replacement(value) {
    return {
      message: value.message,
      stack: value.stack
    };
  }
};